"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHIPPING_ACTION_TYPE = void 0;
exports.SHIPPING_ACTION_TYPE = {
    SET_CG_RETAILER: 'SET_CG_RETAILER',
    SET_DTG_PRODUCT_ID: 'SET_DTG_PRODUCT_ID',
    SET_SHIPPING_METHOD: 'SET_SHIPPING_METHOD'
};
//# sourceMappingURL=shippingActionType.js.map